export const PAYMENT_MOLLIE_INSTITUTION_ID = 'PAYMENT_MOLLIE_NL';

const PAYMENT_PROVIDER_INSTITUTION_IDS = new Set([
    PAYMENT_MOLLIE_INSTITUTION_ID,
]);

const INSTITUTION_DISPLAY_NAMES: Record<string, string> = {
    [PAYMENT_MOLLIE_INSTITUTION_ID]: 'Mollie',
};

export const CONNECTION_METHOD_FINANCIAL_SERVICE = 'financial_service';

export function isPaymentProviderInstitution(institutionId: string | null | undefined): boolean {
    return institutionId != null && PAYMENT_PROVIDER_INSTITUTION_IDS.has(institutionId);
}

export function resolvePaymentProviderDisplayName(integration: string | null | undefined): string | null {
    if (integration == null || !isPaymentProviderInstitution(integration)) {
        return null;
    }
    return resolveInstitutionDisplayName(integration);
}

export type ConnectInstitutionOption = {
    id: string;
    name: string;
    connection_method?: string;
};

export function getConnectOptionDisplayName(option: ConnectInstitutionOption): string {
    if (option.connection_method === CONNECTION_METHOD_FINANCIAL_SERVICE) {
        return resolveInstitutionDisplayName(option.id);
    }
    return option.name;
}

export function resolveInstitutionDisplayName(institutionId: string | null | undefined): string {
    if (!institutionId?.trim()) {
        return '-';
    }
    return INSTITUTION_DISPLAY_NAMES[institutionId] ?? institutionId;
}

export function formatBankAccountIdentifier(
    iban: string | null | undefined,
    institutionName: string | null | undefined,
): string {
    if (iban != null && iban !== '') {
        return iban;
    }
    return resolveInstitutionDisplayName(institutionName);
}

export function formatBankAccountOptionLabel(
    iban: string | null | undefined,
    institutionName: string | null | undefined,
): string {
    const institutionId = institutionName?.trim();
    if (!institutionId) {
        return iban ?? '-';
    }

    const mappedName = INSTITUTION_DISPLAY_NAMES[institutionId];
    if (mappedName != null) {
        return mappedName;
    }

    if (iban != null && iban !== '') {
        return `${institutionId} — ${iban}`;
    }
    return institutionId;
}

export function formatOwnerWithAccountIdentifier(
    ownerName: string,
    iban: string | null | undefined,
    institutionName: string | null | undefined,
): string {
    const identifier = formatBankAccountIdentifier(iban, institutionName);
    if (identifier === '-') {
        return ownerName;
    }
    return `${ownerName} - ${identifier}`;
}
